import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import SchoolIcon from '@material-ui/icons/SchoolOutlined';

import classes from '../../css/getCSS';

const educationInfo = (props) => {
  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('educationinfo')}>Edit</Button>
    );
  }
  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <SchoolIcon className={classes.titleIcon} />
          Education &amp; Career
        </Typography>
        <br />
        <Grid container>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Qualification</p>
            <p className={classes.profileVal}>
              {props.profile.educationinfo.qualification
                ? props.profile.educationinfo.qualification.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Degree</p>
            <p className={classes.profileVal}>{props.profile.educationinfo.degree}</p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>About my education</p>
            <p className={classes.profileVal}>{props.profile.educationinfo.about_education}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Profession</p>
            <p className={classes.profileVal}>
              {props.profile.educationinfo.profession
                ? props.profile.educationinfo.profession.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Work Profile</p>
            <p className={classes.profileVal}>
              {props.profile.educationinfo.work_profile
                ? props.profile.educationinfo.work_profile.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Income</p>
            <p className={classes.profileVal}>
              {props.profile.educationinfo.income
                ? props.profile.educationinfo.income.label : '-'}
            </p>
            <br />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p className={classes.profileCap}>About my work</p>
            <p className={classes.profileVal}>{props.profile.educationinfo.about_career}</p>
            <br />
          </Grid>

        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default educationInfo;



// WEBPACK FOOTER //
// ./src/profile/components/EducationInfo.js